import { Loader2, Plus, Search } from "lucide-react";
import Button from "@/shared/components/button";
import type Plan from "../models/Plan";
import { PlanRow } from "./plan_row";
import { useNavigate } from "react-router-dom";

interface PlansTableProps {
  plans: Plan[];
  loading: boolean;
  error: Error | null;
  onDelete: (id: string) => void;
}

export function PlansTable({ plans, loading, error, onDelete }: PlansTableProps) {
  const navigate = useNavigate();
  return (
    <div className="bg-white/60 backdrop-blur-sm border border-black/5 rounded-2xl shadow-sm overflow-hidden mb-8">
      {/* Table Header */}
      <div className="grid grid-cols-5 gap-4 px-6 py-4 bg-black/3 border-b border-black/5 text-xs font-bold text-foreground/40 uppercase tracking-widest">
        <span>Plan</span>
        <span>Descripción</span>
        <span>Precio</span>
        <span>Duración</span>
        <span />
      </div>

      {loading && (
        <div className="flex justify-center py-16">
          <Loader2 className="size-8 animate-spin text-accent" />
        </div>
      )}

      {error && (
        <div className="text-center py-16 text-red-500">
          <p>Error al cargar los planes: {error.message}</p>
        </div>
      )}

      {!loading && !error && plans.length === 0 && (
        <div className="flex flex-col items-center justify-center py-20 text-foreground/20">
          <Search className="size-10 mb-3 opacity-30" />
          <p className="text-sm font-medium">No hay planes registrados</p>
        </div>
      )}

      {!loading &&
        !error &&
        plans.map((p, i) => (
          <PlanRow
            key={p.id}
            plan={p}
            isLast={i === plans.length - 1}
            onDelete={onDelete}
          />
        ))}

      {/* Add Plan Row */}
      <div className="px-6 py-4 border-t border-black/5 bg-black/2">
        <Button
          variant="ghost"
          className="h-9 px-4 rounded-xl text-accent font-semibold text-sm"
          onClick={() => navigate("new")}
        >
          <Plus className="size-4" />
          Agregar plan
        </Button>
      </div>
    </div>
  );
}
